<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "dictionaryWrapper"
};
</script>

<style scoped></style>
